import { ComponentF } from "../../../ui/ui";
import Colors from "../../Colors";
import { Item } from "../../items/Item";

export const ItemInfoDisplay: ComponentF<{ item: Item | null }> = (
  C,
  { item }
) => {
  if (item === null) {
    C.display.drawText(C.bounds.x, C.bounds.y, `None`);
    return;
  }

  let lines = C.display.drawText(
    C.bounds.x,
    C.bounds.y,
    item.breed.info,
    C.bounds.w - 1
  );

  lines += 1;
  lines += C.display.drawText(
    C.bounds.x,
    C.bounds.y + lines,
    `%c{${Colors.B_GREY_3}}${item.breed.description}`,
    C.bounds.w - 1
  );

  let statY = lines + C.bounds.y + 1;
  const breed = item.breed;

  if (item.uses) {
    C.display.drawText(
      C.bounds.x,
      statY,
      `Uses: ${item.uses.current} / ${item.uses.max}`
    );
    statY += 1;
  }

  if (breed.stats) {
    breed.stats.weight != null &&
      C.display.drawText(C.bounds.x, statY, `Weight: ${breed.stats.weight}`);
    breed.stats.armor != null &&
      C.display.drawText(C.bounds.x, statY + 1, `Armor:  ${breed.stats.armor}`);
    breed.stats.poise != null &&
      C.display.drawText(C.bounds.x, statY + 2, `Poise:  ${breed.stats.poise}`);
  }
};
